import { Box, Typography } from "@mui/material";
import React from "react";

// status images
import RefundedSucces from "../../../assets/RefundedSucces.png";
import refundFailed from "../../../assets/refundfailed.png";
import Order_Successful from "../../../assets/Order_Successful.png";
import REFUND_UPON_REQUEST_IMG from "../../../assets/REFUND_UPON_REQUEST_IMG.png"

// timeline images
import completedStep from "../../../assets/step2.png";
import pendingStep from "../../../assets/step1.png";

const convertToIST = (dateString) => {
  if (!dateString) return "";

  // Force UTC
  const date = new Date(dateString + "Z");

  return date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

// ✅ MOVE CONFIG OUTSIDE (performance best practice)


const RefundStatusCard = ({
  refundStatus,
  refundAmount,
  payMethod,
  refundDetailInfoList,
  imgWidth = 90,
  imgHeight = 90,
}) => {
console.log("refundDetailInfoList",convertToIST(refundDetailInfoList[0].refundCreditExpectedTime))
const refundConfig = {
  REFUND_SCHEDULED: {
    title: "Refund Scheduled",
    titleColor: "#02869e",
    icon: RefundedSucces,
    message:
      "You Will receive your refund with in 40 minutes.",
  },

  REFUND_NOT_REQUIRED: {
    title: "Order Success",
    titleColor: "#00a676",
    icon: Order_Successful,
    imgWidth: "200px",
    imgHeight: "200px",
  },


REFUND_FAILED:  {
    title: "Refund Failed",
    titleColor: "#d32f2f",
    icon: refundFailed,
    message: `Refund Could Not Be Processed Due To A Technical Issue , Failure Reference Number is ${refundDetailInfoList[0].transactionId} `,
  },
  REFUND_INITIATION_FAILED: {
    title: "Refund Initiation Failed",
    titleColor: "#d32f2f",
    icon: refundFailed,
    message: "We encountered an issue while processing your refund.",
  },

REFUND_UPON_REQUEST: {
    title: "Refund Initiation Failed",
    titleColor: "#d37e2f",
    icon: REFUND_UPON_REQUEST_IMG,
    message: "Looks like There May Be A Problem With Your Order.",
  },


  // ✅ CUSTOM IMAGE TIMELINE
  REFUND_SUCCESSFUL: {
    timeline: true,
    icon: completedStep,
    steps: [
      {
        title: "Refund Initiated",
        description:
            `Refund Reference Number : ${refundDetailInfoList[0].transactionId}, ${convertToIST(refundDetailInfoList[0].refundInitiatedTime)} `,
       
      },
      {
        title: "Refund Processing By Bank",
        description:
           `Expected Settlement By ${convertToIST(refundDetailInfoList[0].refundCreditTime)}`,
        
      },
    ],
  },
  REFUND_INITIATED: {
    timeline: true,
    icon: pendingStep,
    steps: [
      {
        title: "Refund Initiated",
        description:
          `Refund Reference Number : ${refundDetailInfoList[0].transactionId}, ${convertToIST(refundDetailInfoList[0].refundInitiatedTime)} `,
       
      },
      {
        title: "Refund Processing By Bank",
        description:
          `Expected Settlement By ${convertToIST(refundDetailInfoList[0].refundCreditExpectedTime)}`,
        
      },
    ],
  },
};


  const data = refundConfig[refundStatus];
  if (!data) return null;


if (data.timeline) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
       // px: 3,
        mt: 4,
        //maxWidth: 420,
        mx: "auto",
      }}
    >
      {/* LEFT FULL IMAGE */}
      <Box
        component="img"
        src={data.icon} // <-- your tall timeline image
        alt=""
        sx={{
          width: 28,
          height: "114px",
          mr: 2.5,
        }}
      />

      {/* RIGHT CONTENT */}
      <Box>
        {data.steps.map((step, index) => (
          <Box key={index} mb={4}>
            <Typography fontWeight={700} fontSize={14}>
              {step.title}
            </Typography>

   <Typography
   fontSize={12}
  color="text.secondary"
  sx={{
    wordBreak: "break-word",
    overflowWrap: "break-word",
    whiteSpace: "normal",
  }}
>
  {step.description}
</Typography>


          </Box>
        ))}
      </Box>
    </Box>
  );
}


  // ✅ NORMAL STATUS UI
  return (
    <Box textAlign="center" mt={data.title === "Order Success" ? 0 : 5} p={0} >
      
      {/* Image */}
      <Box display="flex" justifyContent="center">
        <Box
          component="img"
          src={data.icon}
          alt={data.title}
          sx={{
            width: data.imgWidth || imgWidth,
            height: data.imgHeight || imgHeight,
            objectFit: "contain",
          }}
        />
      </Box>

      {/* Title */}
      <Typography
        mt={data.title === "Order Success" ? 0 : 2}
        fontWeight={700}
        fontSize={{ xs: 14, sm: 22 }}
        color={data.titleColor || "text.primary"}
      >
        {data.title}
      </Typography>

      {/* Message */}
      {data.message && (
        <Box
          sx={{
            mt: 2,
            border: "1px dashed #dcdcdc",
            borderRadius: 3,
            p: 2,
            maxWidth: 420,
            mx: "auto",
            backgroundColor: "#fafafa",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            {data.message}
          </Typography>
        </Box>
      )}
      {console.log("refundStatus--------",refundStatus)}
                {/* REFUND AMOUNT */}
              {(refundStatus === "REFUND_SCHEDULED") &&
                <Box
                  mt={2}
                  sx={{
                    bgcolor: "#eef7f4",
                    borderRadius: 2,
                    p: 2,
                  }}
                >
                  <Typography fontWeight={700} textAlign={"justify"} style={{fontSize:"14px"}}>
                    Amount To Be Refunded : ₹{refundAmount}
                  </Typography>
      
                  <Typography variant="body2" color="text.secondary" textAlign={"justify"} style={{fontSize:"12px"}}>
                    Amount Will Be Refunded To Source {payMethod}
                  </Typography>
                </Box>
                }


          

                             {(refundStatus === "REFUND_FAILED") &&
                <Box
                  mt={2}
                  sx={{
                    bgcolor: "#eef7f4",
                    borderRadius: 2,
                    p: 2,
                  }}
                >
                  <Typography fontWeight={700} textAlign={"justify"}  style={{fontSize:"14px"}}>
                    Amount To Be Refunded : ₹{refundAmount}
                  </Typography>
      
                  <Typography variant="body2" color="text.secondary" textAlign={"justify"}  style={{fontSize:"12px"}}>
                   Expected Settlement Time : Refund Processing (refund schedule time +60 minutes)
                  </Typography>
                </Box>
                }
                     {(refundStatus === "REFUND_INITIATION_FAILED") &&
                <Box
                  mt={2}
                  sx={{
                    bgcolor: "#eef7f4",
                    borderRadius: 2,
                    p: 2,
                  }}
                >
                  <Typography fontWeight={700} textAlign={"justify"}  style={{fontSize:"14px"}}>
                    Amount To Be Refunded : ₹{refundAmount}
                  </Typography>
      
                  <Typography variant="body2" color="text.secondary" textAlign={"justify"}  style={{fontSize:"12px"}}>
                    Amount Will Be Refunded To Source {payMethod}
                  </Typography>
                </Box>
                }


                                 {(refundStatus === "REFUND_UPON_REQUEST") &&
                <Box
                  mt={2}
                  sx={{
                    bgcolor: "#eef7f4",
                    borderRadius: 2,
                    p: 2,
                  }}
                >
                  <Typography fontWeight={700} textAlign={"justify"}  style={{fontSize:"14px"}}>
                    Amount To Be Refunded : ₹{refundAmount}
                  </Typography>
      
                  <Typography variant="body2" color="text.secondary" textAlign={"justify"}  style={{fontSize:"12px"}}>
                    Amount Will Be Refunded To Source {payMethod}
                  </Typography>
                </Box>
                }

                                  {(refundStatus === "REFUND_UPON_REQUEST") &&
                <Box
                  mt={2}
                  sx={{
                    bgcolor: "#eef7f4",
                    borderRadius: 2,
                    p: 2,
                  }}
                >
                  <Typography fontWeight={700} textAlign={"justify"}  style={{fontSize:"14px"}}>
                    Amount To Be Refunded : ₹{refundAmount}
                  </Typography>
      
                  <Typography variant="body2" color="text.secondary" textAlign={"justify"}  style={{fontSize:"12px"}}>
                    Amount Will Be Refunded To Source {payMethod}
                  </Typography>
                </Box>
                }

                                        {(refundStatus === "REFUND_SUCCESSFUL") &&
                <Box
                  mt={2}
                  sx={{
                    bgcolor: "#eef7f4",
                    borderRadius: 2,
                    p: 2,
                  }}
                >
                  <Typography fontWeight={700} textAlign={"justify"}  style={{fontSize:"14px"}}>
                    Amount To Be Refunded : ₹{refundAmount}
                  </Typography>
      
                  <Typography variant="body2" color="text.secondary" textAlign={"justify"}  style={{fontSize:"12px"}}>
                    Amount Will Be Refunded To Source {payMethod}
                  </Typography>
                </Box>
                }

                                              {(refundStatus === "REFUND_INITIATED") &&
                <Box
                  mt={2}
                  sx={{
                    bgcolor: "#eef7f4",
                    borderRadius: 2,
                    p: 2,
                  }}
                >
                  <Typography fontWeight={700} textAlign={"justify"}  style={{fontSize:"14px"}}>
                    Amount To Be Refunded : ₹{refundAmount}
                  </Typography>
      
                  <Typography variant="body2" color="text.secondary" textAlign={"justify"}  style={{fontSize:"12px"}}>
                    Amount Will Be Refunded To Source {payMethod}
                  </Typography>
                </Box>
                }
                
                

                

    </Box>
  );
};

export default RefundStatusCard;
